import { Link } from "react-router-dom";

const LINK_RE = /\[([^\]]+)\]\((\/[^)\s]+|https?:\/\/[^)\s]+)\)/g;
const CLS = "text-blue-400 hover:text-blue-300 underline underline-offset-2 transition-colors";

export function RichText({ text }) {
  if (typeof text !== "string" || !text.includes("](")) return text;
  const parts = [];
  let last = 0;
  let m;
  let i = 0;
  LINK_RE.lastIndex = 0;
  while ((m = LINK_RE.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const href = m[2];
    parts.push(
      href.startsWith("/") ? (
        <Link key={i++} to={href} className={CLS}>{m[1]}</Link>
      ) : (
        <a key={i++} href={href} target="_blank" rel="noopener noreferrer" className={CLS}>{m[1]}</a>
      )
    );
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts}</>;
}
